export default __webpack_public_path__ + "static/media/DSIR.8ea8bda0.jpg";